import React, { FC } from 'react';
import './styles';
import ItvWinWhiteLogo from '../../../../assets/Itv/Win_White 1.svg';

export const Logo: FC = () => {
  return <img src={ItvWinWhiteLogo} alt="ITV Win" className="logo" data-component="ItvWinLogo" />;
};
